//import firebase from "firebase";
import { initializeApp } from 'firebase/app';
//import "firebase/messaging";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import { ToastContainer, toast } from 'react-toastify';


const firebaseConfig = {
    apiKey: "AIzaSyDIhffZZ4EB7NJ3rWssfdA57TJJayqGtc4",
    authDomain: "myjouleboxcommercialapp.firebaseapp.com",
    projectId: "myjouleboxcommercialapp",
    storageBucket: "myjouleboxcommercialapp.appspot.com",
    messagingSenderId: "1086446722255",
    appId: "1:1086446722255:web:32f1e185112e731fe32bba",
    measurementId: "G-70BV0ZD3JX"
  }

// firebase.initializeApp(firebaseConfig);
// const messaging = firebase.messaging();
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

/*
messaging.onMessage((payload)=>{
  console.log('Message => ',payload)
  console.log('Message reçu=> ',payload.notification.body)
  toast.dark(payload.notification.body)
})*/

//curl -X POST --header "Authorization: key=AAAA_PVFXM8:APA91bGLOxxrguTE_ppjb1t0l_H1_cjWJ1bx-jmEbTqNi3_jTul7Ig4IPlfCujv4MOnoP-8iW4g_N3oiOcqz2VOVOXmnoDxUt6O7vBN6TibPe15EbDWFakVZDY3Jr9LUKc-weNGubgIt" --Header "Content-Type: application/json" https://fcm.googleapis.com/fcm/send -d '{"to":"e7LwprC9BTFHbMaWGyIR2e:APA91bFUgiN_KDH84BQpKUWksp564GgSaP6iInzy6eV6PCs4Jh-TtZK5jcqA3XYs7BURi74hvKn9RYUoEvOO7_MWIWfZmJdJFNKswgeHyzHm0ZrC6Rjh8VAZ_ki8ESuOENxb1mWuS1IK","notification":{"title":"MyJouleBox","body":"ENTER YOUR MESSAGE HERE","icon":"/img/logo_carre_mjb.jpeg"}}'



export { messaging};